import { TitleCasePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "camelcase" })
export class CamelCasePipe implements PipeTransform {
    transform(value:any): any {
        let newValue=value.replace('-', "- "); 
        let camelcase=TitleCasePipe.prototype.transform(newValue);
        return camelcase.replace('- ', "-");
      }
}
